import React, { useMemo, useState } from "react";

import { ReactComponent as ArrowLeft } from "../../../build/images/ArrowDownTwo.svg";
import { ReactComponent as ArrowRight } from "../../../build/images/ArrowUpTwo.svg";

import "./legend-of-graphic.styles.css";

const LegendOfGraphic = ({
  data = [
    {
      label: "teste",
      value: 2,
      color: "#455CC7",
    },
    {
      label: "teste2",
      value: 2,
      color: "#455CC7",
    },
    {
      label: "teste3",
      value: 2,
      color: "#455CC7",
    },
    {
      label: "teste4",
      value: 2,
      color: "#455CC7",
    },
    {
      label: "teste5",
      value: 2,
      color: "#455CC7",
    },
    {
      label: "teste6",
      value: 2,
      color: "#455CC7",
    },
    {
      label: "teste7",
      value: 2,
      color: "#455CC7",
    },
    {
      label: "teste8",
      value: 2,
      color: "#455CC7",
    },
  ],
  itemsPerPage = 3,
}) => {
  const [page, setPage] = useState(1);
  const totalOfPages = useMemo(() => {
    const hasData = !!data && Array.isArray(data) && data.length > 0;
    if (hasData) {
      const totalOfItems = data.length;
      return Math.ceil(totalOfItems / itemsPerPage);
    }

    return 1;
  }, [data, itemsPerPage]);
  const dataOfPage = useMemo(() => {
    const hasData = !!data && Array.isArray(data) && data.length > 0;
    if (hasData) {
      const totalOfItems = data.length;
      const firstIndex = (page - 1) * itemsPerPage;
      const lasIndex = Math.min(page * itemsPerPage, totalOfItems);
      return data.slice(firstIndex, lasIndex);
    }

    return null;
  }, [data, page, itemsPerPage]);

  const isLeftButtonDisable = useMemo(() => {
    const isPageOne = page === 1;
    if (isPageOne) {
      return true;
    }
    return false;
  }, [page]);

  const isRightButtonDisable = useMemo(() => {
    const isLastPage = page === totalOfPages;
    if (isLastPage) {
      return true;
    }
    return false;
  }, [page, totalOfPages]);

  const handleClickLeft = () => {
    const isPageOne = page === 1;
    if (isPageOne) {
      return;
    }
    setPage(page - 1);
  };

  const handleClickRight = () => {
    const isLastPage = page === totalOfPages;
    if (isLastPage) {
      return;
    }
    setPage(page + 1);
  };

  return (
    <div className="legend-of-graphic">
      <div className="legend-of-graphic__options">
        {dataOfPage &&
          dataOfPage.map((datum, index) => {
            return (
              <div
                className="legend-of-graphic__options__item"
                key={`legend-of-graphic__options--${index}`}
              >
                <div
                  className="legend-of-graphic__options__item__icon"
                  style={{ backgroundColor: datum.color }}
                />
                <span className="legend-of-graphic__options__item__label">{`${datum.label} (${datum.value})`}</span>
              </div>
            );
          })}
      </div>
      <div className="legend-of-graphic__pagination">
        <button
          className={`legend-of-graphic__pagination__left-button ${
            isLeftButtonDisable ? "legend-button-disable" : ""
          }`}
          onClick={handleClickLeft}
        >
          <ArrowLeft />
        </button>
        <div className="legend-of-graphic__pagination__label">{`${page}/${totalOfPages}`}</div>
        <button
          className={`legend-of-graphic__pagination__right-button ${
            isRightButtonDisable ? "legend-button-disable" : ""
          }`}
          onClick={handleClickRight}
        >
          <ArrowLeft />
        </button>
      </div>
    </div>
  );
};

export default LegendOfGraphic;
